function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import Topbar from "/components/core/top-bar-new/top-bar-component";
import CoreAddonsComponent from "/components/addons/core-addons/core-addons-component";
import BasicSegments from "components/segments/basic-segments";
import classnames from "classnames";
import colors from "/styles/colors";
import { withPreviewBaseSegment } from "contexts/preview-base-segment-context";
import { MAIN_ID } from "constants/element-ids";
import { StyledFixedLongLpTemplate } from "./fixed-long-lp-template.scss";
import BaseTemplate from "../base-template";
class FixedLongLpTemplate extends PureComponent {
    render() {
        const { headerUrl, exitPopup, pageConfig } = this.props;
        const { topbar, topBanner, exitPopupConfig } = pageConfig;
        return /*#__PURE__*/ _jsxs(BaseTemplate, _object_spread_props(_object_spread({}, this.props, pageConfig), {
            children: [
                /*#__PURE__*/ _jsx(Topbar, _object_spread_props(_object_spread({}, topbar), {
                    url: headerUrl,
                    headerBackgroundColor: "white",
                    topBanner: topBanner,
                    maxWidth: "100%",
                    showMenu: false
                })),
                /*#__PURE__*/ _jsxs("main", {
                    id: MAIN_ID,
                    children: [
                        " ",
                        this.renderBasicSegments()
                    ]
                }),
                /*#__PURE__*/ _jsx(CoreAddonsComponent, {
                    exitPopup: exitPopup,
                    exitPopupConfig: exitPopupConfig
                })
            ]
        }));
    }
    constructor(...args){
        super(...args);
        _define_property(this, "getSegmentStyle", (segment)=>{
            const { paddingTop, paddingBottom, backgroundColor, textColor } = segment.props;
            const actualBackgroundColor = colors[backgroundColor];
            const color = colors[textColor];
            const segmentStyleOverride = segment.baseSegmentStyleOverride || {};
            return _object_spread({
                paddingTop,
                paddingBottom,
                color,
                backgroundColor: actualBackgroundColor
            }, segmentStyleOverride);
        });
        _define_property(this, "renderSegment", (segment)=>{
            const SegmentComponent = BasicSegments[segment.type];
            if (!SegmentComponent) return null;
            const { isFullWidth } = segment.props;
            const style = this.getSegmentStyle(segment);
            return /*#__PURE__*/ _jsx(StyledFixedLongLpTemplate, {
                className: "base-layout-segment-component",
                style: style,
                children: /*#__PURE__*/ _jsx("div", {
                    className: classnames("segment-content-container", {
                        "full-width": isFullWidth
                    }),
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "segment-wrapper",
                        children: /*#__PURE__*/ _jsx(SegmentComponent, _object_spread({}, segment.props))
                    })
                })
            });
        });
        _define_property(this, "renderBasicSegments", ()=>{
            const { pageConfig, isPreview } = this.props;
            const { segments } = pageConfig;
            return segments.map((segment, index)=>{
                const Segment = ()=>this.renderSegment(segment);
                const Component = isPreview ? withPreviewBaseSegment(Segment) : Segment;
                return /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx(Component, {
                        index: index
                    })
                }, index);
            });
        });
    }
}
export { FixedLongLpTemplate as default };
FixedLongLpTemplate.defaultProps = {
    headerUrl: "https://monday.com/",
    title: "monday.com",
    description: "",
    exitPopup: true,
    topbar: {}
};
